import { style } from "@vanilla-extract/css";
import { theme } from "@huub-web/ui/theme/css/theme.css";

export const ruleListStyle = style({
  listStyle: "none",
  padding: 0,
  margin: 0,
});

export const checkIconWrapperStyle = style({
  display: "inline-flex",
});

/**
 * Indent sub-rules to align with the parent group header text.
 * 28px = check icon size "s" (16px) + gap "xs" (12px)
 */
export const groupedRuleStyle = style({
  paddingLeft: 28,
  marginTop: 6,
});

/**
 * Soft-bordered box for the password requirements list,
 * with border radius matching the input fields.
 */
export const requirementsBoxStyle = style({
  border: `1px solid ${theme.colors.softBorder}`,
  borderRadius: theme.borderRadiuses.xs,
});

/**
 * Visually hides content while keeping it accessible to screen readers.
 */
export const srOnlyStyle = style({
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: 0,
});
